import {Component, Input, ViewEncapsulation} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {VerticalType} from "../questionnaire-form/questionnaire-form.component";

@Component({
  templateUrl: './successpage.component.html',
  styleUrls: [ './successpage.component.scss'],
  selector: 'successPageComponent',
  encapsulation: ViewEncapsulation.None,
})

export class SuccessPageComponent {

  public verticalType: number;

  constructor(protected route: ActivatedRoute) {

    this.route.url.subscribe((parts: any) => {
      if(parts[0].path.indexOf('remodel') === 0) {
        this.verticalType = VerticalType.Remodeling;
      }
      else if(parts[0].path.indexOf('insurance') === 0){
        this.verticalType = VerticalType.Insurance;
      }
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/lead-form/successpage/successpage.component.ts